<template>
  <el-card class="profile-card">
    <div slot="header" class="clearfix">
      <span><i class="el-icon-user"></i> 个人信息</span>
    </div>
    <div class="content-box">
      <div class="avatar-box">
        <el-upload
          list-type="picture-card"
          :headers="uploadHeaders"
          :action="UPLOAD_URL"
          class="avatar-uploader"
          :file-list="imagesList"
          :show-file-list="false"
          :on-remove="handleImageRemove"
          :on-success="handleImageSuccess"
          :on-exceed="handleExceed"
          :limit="1"
        >
          <img v-if="user.avatar" :src="user.avatar" class="avatar-img" />
          <div v-else class="avatar-placeholder">
            <i class="el-icon-plus"></i>
          </div>
        </el-upload>
      </div>

      <div class="info-box">
        <el-form label-width="85px" class="info-form" :model="user">
          <el-form-item label="姓名">
            <el-input v-model="user.name" disabled style="width: 350px" />
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="user.mobile" disabled style="width: 350px" />
          </el-form-item>
          <el-form-item label="职务">
            <el-input v-model="user.roleName" disabled style="width: 350px" />
          </el-form-item>
          <el-form-item label="密码">
            <el-input
              type="password"
              v-model="user.roleName"
              disabled
              style="width: 350px"
            />
            <el-button
              @click="openChangePasswordDialog"
              style="margin-left: 10px"
              >修改密码</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- 修改密码弹窗 -->
    <el-dialog
      title="修改密码"
      :visible.sync="changePasswordDialogVisible"
      width="550px"
      @close="resetChangePasswordForm"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        :model="changePasswordForm"
        ref="changePasswordForm"
        :rules="changePasswordRules"
        label-width="100px"
      >
        <el-form-item label="原密码" prop="oldPwd">
          <el-input
            v-model="changePasswordForm.oldPwd"
            type="password"
            placeholder="请输入原密码"
            style="width: 350px"
          />
        </el-form-item>
        <el-form-item label="新密码" prop="newPwd">
          <el-input
            v-model="changePasswordForm.newPwd"
            type="password"
            placeholder="请输入新密码"
            style="width: 350px"
          />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            v-model="changePasswordForm.confirmPassword"
            type="password"
            placeholder="请确认新密码"
            style="width: 350px"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changePasswordDialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="submitChangePasswordForm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import { getToken } from "@/utils/auth";
import { personInfo, resetPwd, editAvatar } from "@/api/user";
import { UPLOAD_URL } from "@/utils/const";

export default {
  data() {
    return {
      UPLOAD_URL,
      uploadHeaders: {
        token: getToken(), // 替换为你的 token
      },
      user: {},
      imagesList: [],
      images: "", //后台的地址
      // 控制弹窗的显示
      changePasswordDialogVisible: false,
      // 修改密码表单数据
      changePasswordForm: {
        oldPwd: "",
        newPwd: "",
        confirmPassword: "",
      },

      // 修改密码表单校验规则
      changePasswordRules: {
        oldPwd: [{ required: true, message: "请输入原密码", trigger: "blur" }],
        newPwd: [{ required: true, message: "请输入新密码", trigger: "blur" }],
        confirmPassword: [
          { required: true, message: "请确认新密码", trigger: "blur" },
          { validator: this.validateConfirmPassword, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getInfo();
  },

  methods: {
    handleExceed() {
      this.$message.warning(`本次只能上传1张图片`);
    },
    // 处理图片移除
    handleImageRemove(file, fileList) {
      this.imagesList = fileList;
    },

    // 处理图片变化（上传新图片时）
    handleImageSuccess(data, file) {
      if (data.code === 0) {
        // 上传成功
        this.images = data.data;
        // 更新头像
        editAvatar({
          avatar: data.data,
        }).then(() => {
          this.$message.success("头像上传成功");
          this.getInfo();
        });
      }
      this.imagesList.push(file);
    },
    getInfo() {
      personInfo().then((res) => {
        this.user = res;
      });
    },
    handleAvatarChange(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.user.avatarUrl = e.target.result;
      };
      reader.readAsDataURL(file.raw);
    },
    // 打开修改密码弹窗
    openChangePasswordDialog() {
      this.changePasswordForm = {
        oldPwd: "",
        newPwd: "",
        confirmPassword: "",
      };
      this.changePasswordDialogVisible = true;
    },
    // 表单提交
    submitChangePasswordForm() {
      this.$refs.changePasswordForm.validate((valid) => {
        if (valid) {
          const params = {
            oldPwd: this.changePasswordForm.oldPwd,
            newPwd: this.changePasswordForm.newPwd,
          };
          resetPwd(params)
            .then(() => {
              this.$message.success("密码修改成功");
              this.changePasswordDialogVisible = false;
            })
            .catch(() => {
              this.$message.error("密码修改失败");
            });
        } else {
          return false;
        }
      });
    },

    // 确认密码校验
    validateConfirmPassword(rule, value, callback) {
      if (value !== this.changePasswordForm.newPwd) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    },
    // 关闭弹窗时重置表单
    resetChangePasswordForm() {
      this.changePasswordForm = {
        oldPwd: "",
        newPwd: "",
        confirmPassword: "",
      };
    },
  },
};
</script>

<style scoped>
.profile-card {
  width: 100%;
}

.avatar-box {
  flex-shrink: 0;
  margin-left: 180px;
}

.avatar-uploader {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px !important;
  height: 100px !important;
  border-radius: 50%;
  overflow: hidden;
  border: 1px solid #eee;
}

/deep/ .el-upload--picture-card {
  width: 100px;
  height: 100px;
}


.avatar-img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 50%;
}

.avatar-placeholder {
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  color: #999;
  background: #f0f0f0;
  border-radius: 50%;
  font-size: 14px;
}

.info-box {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 50px;
}

.info-item {
  font-size: 14px;
  color: #333;
}

.content-box {
  padding: 20px 60px;
}
.certificate-img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
}
</style>
